import React, { useEffect, useState } from "react";
import { Card, Table } from "antd";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import PageTransition from "../../components/ui/PageTransition";
import PageHeader from "../../components/ui/PageHeader";
import EmptyState from "../../components/ui/EmptyState";

const Holidays = () => {
  const { request } = useRequest();
  const [holidays, setHolidays] = useState([]);

  const fetchHolidays = () => {
    request({ url: apiPath.holidays, method: "GET", onSuccess: (res) => setHolidays(res?.data?.data || []) });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchHolidays, []);

  const columns = [
    { title: "Name", dataIndex: "name" },
    { title: "Date", dataIndex: "date" },
    { title: "Description", dataIndex: "description" },
  ];

  return (
    <PageTransition>
      <PageHeader title="Holiday Calendar" subtitle="Upcoming and past company holidays" />
      <Card>
        <Table
          rowKey="_id"
          columns={columns}
          dataSource={holidays}
          pagination={{ pageSize: 10 }}
          locale={{ emptyText: <EmptyState message="No holidays listed yet" /> }}
        />
      </Card>
    </PageTransition>
  );
};

export default Holidays;
